import { Dropdown, Option } from '@risk-first/ui-dropdown';
import { apps } from '../../data/apps';
import { useSelectedApp } from '../../hooks/use-selected-app';
import { useSelectedTenant } from '../../hooks/use-selected-tenant';
import { isLocalhost } from '../../utils/is-localhost';

export const AppChooser: React.FC = () => {
  const selectedApp = useSelectedApp();
  const selectedTenant = useSelectedTenant();

  return (
    <Dropdown
      label={selectedApp?.name ?? 'Select an application'}
      value={selectedApp?.id}
      variant="select"
      onChange={(selectedAppId: string) => {
        if (isLocalhost()) {
          document.location.search = `?app=${selectedAppId}`;
        } else {
          document.location = `https://${selectedAppId}.pfaroe.net/${selectedTenant?.id ?? ''}`;
        }
      }}
    >
      {apps.map((app, index) => (
        <Option key={app.id} index={index} value={app.id}>
          {app.name}
        </Option>
      ))}
    </Dropdown>
  );
};
